import styles from './Verified.module.scss';
import { ReactComponent as VerifiedSVG } from '../../../assets/verified.svg';

interface IVerifiedProps {
    isVerified: boolean;
}

export const Verified = ({ isVerified }: IVerifiedProps) => {
    return (
        <div className={isVerified ? styles.verified : styles.notVerified}>
            <VerifiedSVG />
        </div>
    );
};
